export default __webpack_public_path__ + "static/media/d7.aafc4170.png";